// Generated by scripts/game_player/generate.mjs
export const NATIVE_GAME_WINDOW_POLICY = Object.freeze({
  nativeCloseFallbackMs: 2000,
});
